export default __webpack_public_path__ + "static/goofy-laugh-fbb5e031e266d2b3be2483a901fb2bb3.mp3";